import React from 'react';
import { AlertCircle, AlertTriangle } from 'lucide-react';
import { ConstraintViolation } from '../../core/types.ts';

interface LintBadgeProps {
  violations: ConstraintViolation[];
  onClick?: () => void;
}

export const LintBadge: React.FC<LintBadgeProps> = ({ violations, onClick }) => {
  if (!violations || violations.length === 0) return null;

  const hardCount = violations.filter(v => v.severity === 'hard').length;
  const softCount = violations.filter(v => v.severity === 'soft').length;

  if (hardCount > 0) {
    return (
      <span
        className="lint-indicator hard"
        onClick={onClick}
        title={violations.map(v => `${v.ruleName}: ${v.message}`).join('\n')}
      >
        <AlertCircle size={12} />
        <span>{hardCount} Hard Error{hardCount > 1 ? 's' : ''}</span>
      </span>
    );
  }

  if (softCount > 0) {
    return (
      <span
        className="lint-indicator soft"
        onClick={onClick}
        title={violations.map(v => `${v.ruleName}: ${v.message}`).join('\n')}
      >
        <AlertTriangle size={12} />
        <span>{softCount} Warning{softCount > 1 ? 's' : ''}</span>
      </span>
    );
  }

  return null;
};
